import {Alert, AspectRatio, IconButton, LinearProgress, Typography} from "@mui/joy";
import {Check, Close} from "@mui/icons-material";


const SuccessAlert = ({ message, onClose }) => {
    return (
        <div style={{width:'350px', position:'fixed', bottom:'20px', right:'20px'}}>
            <Alert
                size="lg"
                color="success"
                variant="solid"
                invertedColors
                startDecorator={
                    <AspectRatio
                        variant="solid"
                        ratio="1"
                        sx={{
                            minWidth: 40,
                            borderRadius: '50%',
                            boxShadow: '0 2px 12px 0 rgb(0 0 0/0.2)',
                        }}
                    >
                        <div>
                            <Check fontSize="xl2" />
                        </div>
                    </AspectRatio>
                }
                endDecorator={
                    <IconButton
                        variant="plain"
                        sx={{
                            '--IconButton-size': '32px',
                            transform: 'translate(0.5rem, -0.5rem)',
                        }}
                        onClick={onClose}
                    >
                        <Close />
                    </IconButton>
                }
                sx={{ alignItems: 'flex-start', overflow: 'hidden' }}
            >
                <div>
                    <Typography level="title-lg">Success</Typography>
                    <Typography level="body-sm">
                        {message}
                    </Typography>
                </div>
                <LinearProgress
                    variant="solid"
                    color="success"
                    value={40}
                    sx={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        borderRadius: 0,
                    }}
                />
            </Alert>
        </div>
    )
}

export default SuccessAlert;